import { clearProductMediaUploads } from "../uploads/productMediaUploadManager";
import { PRODUCT_LIST_BACK_KEY } from "../pages/products/list/productListFilters";

export const STUDIO_PROFILE_NUDGE_KEY = "hkp.studioSignup.nudge";

export function markStudioSignupNudge() {
  sessionStorage.setItem(STUDIO_PROFILE_NUDGE_KEY, "1");
}

export function shouldShowStudioProfileNudge() {
  return sessionStorage.getItem(STUDIO_PROFILE_NUDGE_KEY) === "1";
}

export function clearStudioProfileNudge() {
  sessionStorage.removeItem(STUDIO_PROFILE_NUDGE_KEY);
}

export function isStudioLoggedIn() {
  try {
    const raw = localStorage.getItem("authUser");
    return Boolean(raw && JSON.parse(raw));
  } catch {
    return false;
  }
}

const STUDIO_LIST_CACHE_KEYS = [
  "offsetForProduct",
  "FiltersForProducts",
  "ProductCount",
];

/** Drop previous-session product list filters so a new org starts on an empty inventory page. */
export function clearStudioWorkspaceCaches() {
  STUDIO_LIST_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
  try {
    sessionStorage.removeItem(PRODUCT_LIST_BACK_KEY);
  } catch {
    // Nothing to clear.
  }
  void clearProductMediaUploads();
}
